import { Box } from 'native-base'
import React from 'react'

import { CheckBox } from './CheckBox'

type CheckBoxListType = {
  onPress: (slug: string) => void
  checkBoxList: {
    label: string
    isChecked: boolean
    value: string
  }[]
  layout?: 'vertical' | 'horizontal' | 'grid'
}

export const CheckBoxList = ({ onPress, checkBoxList, layout = 'vertical' }: CheckBoxListType) => {
  const checkBoxListRender = checkBoxList.map(({ label, isChecked, value }) => (
    <CheckBox
      pb={layout === 'vertical' ? '5' : '3'}
      onPress={onPress}
      id={value}
      isChecked={isChecked}
      key={value}
      text={label}
      flex={layout === 'horizontal' ? 1 : undefined}
      minW={layout === 'horizontal' ? '45%' : undefined}
    />
  ))

  if (layout === 'horizontal') {
    return (
      <Box flexDirection="row" flexWrap="wrap" justifyContent="space-between">
        {checkBoxListRender}
      </Box>
    )
  }

  if (layout === 'grid') {
    return (
      <Box flexDirection="row" flexWrap="wrap" justifyContent="space-between">
        {checkBoxListRender.map((item, index) => (
          <Box key={index} width="48%" mb="3">
            {item}
          </Box>
        ))}
      </Box>
    )
  }

  return <>{checkBoxListRender}</>
}
